import axios from "axios";
import {toast} from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import store from "@/store";

// Base API URL
const API_BASE_URL = process.env.VUE_APP_API_URL;

// Create an Axios instance
const apiService = axios.create({
    baseURL: API_BASE_URL,
});

// API repository methods
const apiRepository = {
    POST_COMMAND: "POST",
    GET_COMMAND: "GET",
    PUT_COMMAND: "PUT",
    PUT_DELETE: "DELETE",

    async callApi(method, endpoint, data = null) {
        const url = `${API_BASE_URL}${endpoint}`;
        try {
            const response = await axios({
                method: method,
                url: url,
                data: data,
            });
            return response;
        } catch (error) {
            console.error("API call failed:", error);
            toast.error(error.response?.data || "An error occurred");
            // throw error;
        }
    },

    getAuthHeader() {
        const token = localStorage.getItem("authToken");
        if (token == null) return;
        return {Authorization: `Bearer ${token}`};
    },

    async getRelevantList() {
        try {
            const lang = store.getters.currentLang;
            // const lang = localStorage.getItem("locale") || 'en';
            const response = await apiService.get(`/relevantList?lang=${lang}`);
            return response.data;
        } catch (error) {
            console.error("API Error:", error);
            throw error;
        }
    },

    async getMaritalList() {
        return await axios.get(`${API_BASE_URL}/lookup/maritalList`, {
            headers: this.getAuthHeader()
        })
    },
    async getProfession() {
        const lang = store.getters.currentLang;
        return await axios.get(`${API_BASE_URL}/lookup/professionList?lang=${lang}`, {
            headers: this.getAuthHeader()
        });
    },
    async getCountry() {
        return await axios.get(`${API_BASE_URL}/lookup/countryList`, {
            headers: this.getAuthHeader()
        })
    },
    async getGender() {
        return await axios.get(`${API_BASE_URL}/lookup/gender`, {
            headers: this.getAuthHeader()
        })
    },
    async getAdminUserActivity(param) {
        const token = localStorage.getItem("authToken")
        if (!token) {
            return;
        }
        return await axios.get(`${API_BASE_URL}/admin/all-user-activity-log?filter=${param}`, {
            headers: this.getAuthHeader()
        })
    },
    async getTotalUser() {
        return await axios.get(`${API_BASE_URL}/admin/dashboard/total-user-info`, {
            headers: this.getAuthHeader()
        })
    },
    async getTotalMessage() {
        return await axios.get(`${API_BASE_URL}/admin/dashboard/message-query`, {
            headers: this.getAuthHeader()
        })
    },
    async saveProfileData(data) {
        return await axios.post(`${API_BASE_URL}/lookup/saveProfileData`, data, {
            headers: this.getAuthHeader()
        })
    },
    async returningUser(dateFilter, data) {
        return await axios.get(`${API_BASE_URL}/admin/dashboard/returning-user-info?filter=${dateFilter}&source=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    /*async userDataGet() {
        const token = localStorage.getItem("authToken")
        console.log(token)
        if (!token) {
            return;
        }
        return await axios.get(`${API_BASE_URL}/user/getProfileData`, {
            headers: this.getAuthHeader()
        })
    },*/

    async userDataGet() {
        const token = localStorage.getItem("authToken");
        if (!token) {
            // toast.error('No token found. Please log in again.');
            return;
        }

        try {
            const response = await axios.get(`${API_BASE_URL}/user/getProfileData`, {
                headers: this.getAuthHeader(),
            });
            return response;  // Return the response if successful
        } catch (error) {
            if (error.response) {
                console.error('Your session has expired. Please log in again.');
            } else {
                console.error('An error occurred while fetching user data.');
            }
            console.error(error);  // Log error details
        }
    },
    async getWasiyyah() {
        return await axios.get(`${API_BASE_URL}/user/getWasiyyah`, {
            headers: this.getAuthHeader()
        })
    },

    async changeWasiyyahOrder(data) {
        return await axios.post(`${API_BASE_URL}/user/changeOrder`, data, {
            headers: this.getAuthHeader()
        })
    },
    async saveWasiyyah(data) {
        return await axios.post(`${API_BASE_URL}/user/saveWasiyyah`, data, {
            headers: this.getAuthHeader()
        })
    },
    async newUser(dateFilter, source) {
        const token = localStorage.getItem("authToken")
        if (!token) {
            return;
        }
        return await axios.get(`${API_BASE_URL}/user/newUser?filter=${dateFilter}&source=${source}`, {
            headers: this.getAuthHeader()
        })
    },
    async getWitness() {
        return await axios.get(`${API_BASE_URL}/user/get-witness`, {
            headers: this.getAuthHeader()
        })
    },
    async searchWitness(data) {
        return await axios.get(`${API_BASE_URL}/user/search-witness?email=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    async saveWitness(data) {
        return await axios.post(`${API_BASE_URL}/user/save-witness`, data, {
            headers: this.getAuthHeader()
        })
    },

    async getNominee() {
        return await axios.get(`${API_BASE_URL}/user/get-nominees`, {
            headers: this.getAuthHeader()
        })
    },
    async getImNominee() {
        return await axios.get(`${API_BASE_URL}/get-nomineeByAnotherUser`, {
            headers: this.getAuthHeader()
        })
    },
    async getImWitness() {
        return await axios.get(`${API_BASE_URL}/get-witnessByAnotherUser`, {
            headers: this.getAuthHeader()
        })
    },
    async searchWitnessNominee(data, isWitness) {
        return await axios.get(`${API_BASE_URL}/user/search-witness-nominee?email=${data}&isWitness=${isWitness}`, {
            headers: this.getAuthHeader()
        })
    },

    async getUserActivities(data) {
        const token = localStorage.getItem("authToken")
        if (!token) {
            return;
        }
        return await axios.get(`${API_BASE_URL}/user/user-activity-log?filter=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    async assignWitnessData(data) {
        return await axios.get(`${API_BASE_URL}/user/assign-witness?email=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    async assignNomineeData(data) {
        return await axios.get(`${API_BASE_URL}/user/assign-nominee?email=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    /*async getNotifications() {
        const token = localStorage.getItem("authToken")
        if (!token) {
            return;
        }
        return await axios.get(`${API_BASE_URL}/get-notification`, {
            headers: this.getAuthHeader()
        })
    },*/
    async getNotifications() {
        const token = localStorage.getItem("authToken");
        if (!token) {
            return;
        }
        try {
            const response = await axios.get(`${API_BASE_URL}/get-notification`, {
                headers: this.getAuthHeader(),
            });
            return response;
        } catch (error) {
            if (error.response) {
                console.error('Your session has expired. Please log in again.');
            } else {
                console.error('An error occurred while fetching user data.');
            }
            console.error(error);  // Log error details
        }
    },


    async getBankList() {
        const token = localStorage.getItem("authToken")
        if (!token) {
            return;
        }
        return await axios.get(`${API_BASE_URL}/lookup/bankList`, {
            headers: this.getAuthHeader()
        })
    },
    async getBranchList(id) {
        return await axios.get(`${API_BASE_URL}/lookup/branchList?bankId=${id}`, {
            headers: this.getAuthHeader()
        })
    },
    async acceptRejectRequest(payload) {
        return await axios.get(`${API_BASE_URL}/accept-reject-request?requestKey=${payload.requestKey}&value=${payload.status}`, {
            headers: this.getAuthHeader()
        })
    },
    async getWealthData(lang) {
        return await axios.get(`${API_BASE_URL}/lookup/wealthList?lang=${lang}`, {
            headers: this.getAuthHeader()
        })
    },
    async getWealthDocumentType(payload) {
        const lang = store.getters.currentLang;
        return await axios.get(`${API_BASE_URL}/lookup/documentTypeList?lang=${lang}&wealthId=${payload}`, {
            headers: this.getAuthHeader()
        })
    },
    async getUsersByRole(data) {
        return await axios.get(`${API_BASE_URL}/getUsersByRole?isWitness=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    async permissionVlu() {
        return await axios.get(`${API_BASE_URL}/getContexts`, {
            headers: this.getAuthHeader()
        })
    },
    async assignContextData(payload, trace) {
        return await axios.post(`${API_BASE_URL}/assignContext?isWitness=${trace}`, payload, {
            headers: this.getAuthHeader()
        })
    },
    async getUserContext(payload, trace) {
        return await axios.get(`${API_BASE_URL}/getUserContexts?requestKey=${payload}&trace=${trace}`, {
            headers: this.getAuthHeader()
        })
    },
    async currencyCodeUpdate(data) {
        return await axios.post(`${API_BASE_URL}/user/saveNisab`, data, {
            headers: this.getAuthHeader()
        })
    },
    async getNisab() {
        return await axios.get(`${API_BASE_URL}/user/getNisabRates`, {
            headers: this.getAuthHeader()
        })
    },
    async zakatCalculated(data) {
        const lang = store.getters.currentLang;
        return await axios.post(`${API_BASE_URL}/zakatCalculator?lang=${lang}`, data, {
            headers: this.getAuthHeader()
        })
    },
    async zakatCalculateSave(data) {
        const lang = store.getters.currentLang;
        return await axios.post(`${API_BASE_URL}/user/saveZakatCalculation?lang=${lang}`, data, {
            headers: this.getAuthHeader()
        })
    },
    async getZakatInfoData() {
        return await axios.get(`${API_BASE_URL}/user/getZakatInfo`, {
            headers: this.getAuthHeader()
        })
    },
    async getContextData(requestKey) {
        return await axios.get(`${API_BASE_URL}/getContextsData?requestKey=${requestKey}`, {
            headers: this.getAuthHeader()
        })
    },
    async getMenus() {
        const token = localStorage.getItem("authToken");
        if (!token) {
            // toast.error('No token found. Please log in again.');
            return;
        }
        return await axios.get(`${API_BASE_URL}/user/menu/getMenus`, {
            headers: this.getAuthHeader()
        })
    },
    async savePropertyDetails(data) {
        return await axios.post(`${API_BASE_URL}/savePropertyDistributeResult`, data, {
            headers: this.getAuthHeader()
        })
    },
    async getPropertyDistribute() {
        return await axios.get(`${API_BASE_URL}/getPropertyDistributeResult`, {
            headers: this.getAuthHeader()
        })
    },
    async saveNominee(data) {
        return await axios.post(`${API_BASE_URL}/user/save-nominee`, data, {
            headers: this.getAuthHeader()
        })
    },
    async getPrayersTime(data) {
        return await axios.get(`${API_BASE_URL}/getSalahTime?ip=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    async iPAddressDataGet(data) {
        return await axios.post(`${API_BASE_URL}/admin/saveAllowedIP`, data, {
            headers: this.getAuthHeader()
        })
    },
    async getIpData() {
        return await axios.get(`${API_BASE_URL}/user/getAllowedIpList`, {
            headers: this.getAuthHeader()
        })
    },
    async deleteIp(data) {
        return await axios.post(`${API_BASE_URL}/admin/deleteAllowedIP`, data, {
            headers: this.getAuthHeader()
        })
    },
    async saveBankBranch(payload) {
        return await axios.post(`${API_BASE_URL}/admin/saveBankBranch`, payload, {
            headers: this.getAuthHeader()
        })
    },
    async changePass(payload) {
        return await axios.post(`${API_BASE_URL}/user/update/password`, payload, {
            headers: this.getAuthHeader()
        })
    },
    async blogPost(payload) {
        return await axios.post(`${API_BASE_URL}/admin/saveBlogContent`, payload, {
            headers: this.getAuthHeader()
        })
    },
    async getBlogPost() {
        return await axios.get(`${API_BASE_URL}/admin/getBlogContentList`, {
            headers: this.getAuthHeader()
        })
    },
    async sendCertificateOTP() {
        return await axios.get(`${API_BASE_URL}/user/sendCertificateVerificationOtp`, {
            headers: this.getAuthHeader()
        })
    },

    async modifyCertificate() {
        const lang = store.getters.currentLang;
        return await axios.get(`${API_BASE_URL}/user/modifyCertificate?lang=${lang}`, {
            headers: this.getAuthHeader()
        })
    },

    async verifyCertificateOTP(data) {
        const lang = store.getters.currentLang;
        return await axios.get(`${API_BASE_URL}/user/verifyCertificateOtp?otp=${data}&lang=${lang}`, {
            headers: this.getAuthHeader()
        })
    },

    async getCertificateInfo() {
        return await axios.get(`${API_BASE_URL}/user/getCertificateInfo`, {
            headers: this.getAuthHeader()
        })
    },
    async removeWitnessUser(data) {
        return await axios.get(`${API_BASE_URL}/user/remove-witness?requestKey=${data}`, {
            headers: this.getAuthHeader()
        })
    },
    async nomineeUserRemove(data) {
        return await axios.get(`${API_BASE_URL}/user/remove-nominee?requestKey=${data}`,{
            headers: this.getAuthHeader()
        })
    },
    async lasModifiedWasiyyah() {
        return await axios.get(`${API_BASE_URL}/user/getLastWasiyyahModifiedDate`,{
            headers: this.getAuthHeader()
        })
    },

async getCategoryData() {
    const lang = store.getters.currentLang;
        return await axios.get(`${API_BASE_URL}/lookup/blogCategoryList?lang=${lang}`,{
            headers: this.getAuthHeader()
        })
    },

    async getAllCategoryData() {
        const lang = store.getters.currentLang;
        return await axios.get(`${API_BASE_URL}/lookup/allBlogCategory?lang=${lang}`,{
            headers: this.getAuthHeader()
        })
    },
    async categoryAdd(payload) {
        return await axios.post(`${API_BASE_URL}/admin/saveBlogCategory`, payload, {
            headers: this.getAuthHeader()
        })
    },

    async getMedia() {
        return import.meta.env.VITE_API_URL + '/raw-media/'
    },


};

export default apiRepository;

export function getMedia() {
    return process.env.VUE_APP_API_URL + '/raw-media/';
}

export function getMediaInfo() {
    return process.env.VUE_APP_API_URL + '/raw-media-info/';
}

export function getImage() {
    return process.env.VUE_APP_API_URL + '/raw/';
}
